import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ACCESS_API } from "./apiRoutes";

interface UseGetPermissionByUserIdProps {
  userId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPermissionByUserId = async (userId: string) =>
  await axiosAuth.get(`${ACCESS_API}/user/${userId}`);

const useGetPermissionByUserId = ({
  userId,
  queryParams,
}: UseGetPermissionByUserIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["permission", userId],
    queryFn: () => getPermissionByUserId(userId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPermissionByUserId;
